import { render } from "./BasketModal.vue?vue&type=template&id=f4ee9c8a&scoped=true"
import script from "./BasketModal.vue?vue&type=script&lang=js"
export * from "./BasketModal.vue?vue&type=script&lang=js"

import "./BasketModal.vue?vue&type=style&index=0&id=f4ee9c8a&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ee9c8a"]])

export default __exports__